<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        highlight-hover-row
        :loading="loading"
        :data="tableData"
        :height="tableHeight"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :radio-config="{
          trigger: 'row',
          highlight: true,
        }"
        row-key
        size="small"
        resizable
        border
        empty-text="没有匹配到符合条件的有效门点"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div style="width:500px;">
              <b-form onsubmit="return false">
                <b-input-group size="sm">
                  <b-form-input
                    @keyup.enter="getMasterPoint()"
                    type="search"
                    v-model.trim="formData.keyword"
                    placeholder="输入门点名称或详细地址进行搜索"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      size="sm"
                      @click="getMasterPoint()"
                    >
                      <i class="fa fa-search" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </div>
          </slot>
        </template>
      </vxe-grid>
    </div>
    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="choiceOk" size="small"
        >确认选择</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      tableData: [],
      tableHeight: 380,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '选择',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'radio',
        },
        {
          field: 'pointName',
          headerAlign: 'center',
          align: 'left',
          minWidth: 160,
          title: '门点名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },

        {
          field: 'pointTypeName',
          headerAlign: 'center',
          align: 'center',
          width: 100,
          title: '门点类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },
        {
          field: 'provinceName',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          title: '省份',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },
        {
          field: 'cityName',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          title: '城市',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },
        {
          field: 'districtName',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          title: '区县',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },
        {
          field: 'detailAddress',
          headerAlign: 'center',
          align: 'left',
          width: 170,
          title: '详细地址',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'contactName',
          headerAlign: 'center',
          align: 'left',
          width: 120,
          title: '联系人',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
          sortType: 'string',
        },
        {
          field: 'contactMobile',
          headerAlign: 'center',
          align: 'left',
          width: 120,
          title: '联系人手机',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'contactEmail',
          headerAlign: 'center',
          align: 'left',
          width: 150,
          title: '联系人邮箱',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'pointFence',
          align: 'center',
          width: 100,
          title: '电子围栏半径',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'pointStatusName',
          align: 'center',
          width: 100,
          title: '状态',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'createTime',
          title: '创建时间',
          width: 160,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
        },
        {
          field: 'createByName',
          title: '创建人',
          width: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyTime',
          title: '修改时间',
          width: 160,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: false,
        },
        {
          field: 'modifyByName',
          title: '修改人',
          width: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },

  created() {
    this.getMasterPoint()
  },
  methods: {
    load() {
      this.getMasterPoint()
    },
    getMasterPoint() {
      this.loading = true
      this.$api
        .bizMasterPointList(this.formData)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    close() {
      this.$emit('close')
    },
    choiceOk() {
      let masterPointData = this.$refs.table.getRadioRecord()
      if (!masterPointData) {
        this.$alert('请点击选择需要使用的客户门点', '提示信息', {})
        return
      }
      this.$emit('choiceOk', masterPointData)
    },
  },
}
</script>
